(() => {
  const DOB_SELECTOR = '.main-cart__dob-input, .cart-drawer__dob-input';
  const ATL_SELECTOR =
    '#main-authority-to-leave, #drawer-authority-to-leave';
  const CHECKOUT_SELECTOR = '#checkout, #CartDrawer-Checkout';

  const parseDate = (value) => {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return null;

    const [year, month, day] = value.split('-').map(Number);
    const date = new Date(year, month - 1, day);

    if (
      date.getFullYear() !== year ||
      date.getMonth() !== month - 1 ||
      date.getDate() !== day
    ) {
      return null;
    }

    return date;
  };

  const getEighteenthBirthdayCutoff = () => {
    const today = new Date();
    return new Date(
      today.getFullYear() - 18,
      today.getMonth(),
      today.getDate()
    );
  };

  const formatDateForInput = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const applyDobMaximum = () => {
    const maximumDob = formatDateForInput(getEighteenthBirthdayCutoff());
    document.querySelectorAll(DOB_SELECTOR).forEach((input) => {
      input.max = maximumDob;
    });
  };

  const getDobInputForCheckout = (button) => {
    if (button.id === 'CartDrawer-Checkout') {
      return document.querySelector('.cart-drawer__dob-input');
    }

    return document.querySelector('.main-cart__dob-input');
  };

  const isValidDob = (value) => {
    const dob = parseDate(value);
    return Boolean(dob && dob <= getEighteenthBirthdayCutoff());
  };

  const getErrorMessage = (input) =>
    input.closest('.main-cart__dob-field, .cart-drawer__dob-field')
      ?.querySelector('.error-message');

  const clearError = (input, button) => {
    input.classList.remove('dob-error');
    input.removeAttribute('aria-invalid');
    getErrorMessage(input)?.classList.remove('active');
    button?.classList.remove('checkout-error');
  };

  const showError = (input, button) => {
    input.classList.add('dob-error');
    input.setAttribute('aria-invalid', 'true');
    getErrorMessage(input)?.classList.add('active');

    if (button) {
      button.classList.remove('checkout-error');
      void button.offsetWidth;
      button.classList.add('checkout-error');
    }

    input.scrollIntoView({ behavior: 'smooth', block: 'center' });
    input.focus({ preventScroll: true });
  };

  const validateCheckout = (button) => {
    const input = getDobInputForCheckout(button);
    if (!input) return true;

    if (!isValidDob(input.value)) {
      showError(input, button);
      return false;
    }

    clearError(input, button);
    return true;
  };

  const updateCartAttribute = (name, value) => {
    const updateUrl =
      window.routes?.cart_update_url ||
      `${window.Shopify?.routes?.root || '/'}cart/update.js`;

    return fetch(updateUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ attributes: { [name]: value } }),
    }).catch((error) => {
      console.warn(`Unable to save cart attribute: ${name}`, error);
    });
  };

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest(CHECKOUT_SELECTOR);
      if (!button) return;

      if (!validateCheckout(button)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    (event) => {
      const submitter = event.submitter || document.activeElement;
      if (!submitter?.matches?.(CHECKOUT_SELECTOR)) return;

      if (!validateCheckout(submitter)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true
  );

  document.addEventListener('input', (event) => {
    if (!event.target.matches(DOB_SELECTOR)) return;

    if (isValidDob(event.target.value)) {
      const button =
        event.target.classList.contains('cart-drawer__dob-input')
          ? document.querySelector('#CartDrawer-Checkout')
          : document.querySelector('#checkout');
      clearError(event.target, button);
    }
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches(DOB_SELECTOR)) {
      document.querySelectorAll(DOB_SELECTOR).forEach((input) => {
        if (input !== event.target) input.value = event.target.value;
      });

      updateCartAttribute('Your DOB', event.target.value);
      return;
    }

    if (event.target.matches(ATL_SELECTOR)) {
      document.querySelectorAll(ATL_SELECTOR).forEach((checkbox) => {
        checkbox.checked = event.target.checked;
      });

      updateCartAttribute(
        'Authority To Leave',
        event.target.checked ? 'Yes' : 'No'
      );
    }
  });

  applyDobMaximum();

  let observerFrame;
  const observer = new MutationObserver(() => {
    cancelAnimationFrame(observerFrame);
    observerFrame = requestAnimationFrame(applyDobMaximum);
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();